module.exports = __webpack_public_path__ + "static/media/kids-drawing.917cfa69.jpg";